// NPM dependencies
import $ from 'jquery';
// window.$ = window.jQuery = require('jquery');
// window.$ = window.jQuery = $;
// import datepicker from 'jquery-ui';
// import 'jquery-ui/ui/widgets/datepicker.js';
import 'jquery-ui-bundle';
import 'babel-polyfill';
import 'foundation-sites';
import 'slick-carousel';
// import 'jquery-ias';
import 'magnific-popup';
import objectFitImages from 'object-fit-images';
import 'vanilla-fitvids';
import 'lazysizes';
import pictureFill from 'picturefill';
import 'lightgallery';
import 'lg-thumbnail';
// import InfiniteAjaxScroll from '@webcreate/infinite-ajax-scroll';

// Import vendor stuff that's too old to be imported from npm
// (Required to match old site exactly)
import './vendor/jquery-color-2.1.0';

// IAS, doesn't seem to be working from NPM
// require('jquery-ias/src/callbacks.js');
// require('jquery-ias/src/jquery-ias.js');
// require('./vendor/ias-vendor');

// Project Partials
import JsForm from '../../src/components/01-elements/form/form';
import JsAccordion from '../../src/components/03-ui/accordion/accordion';
import JsCalendar from '../../src/components/01-elements/calendar/calendar';
import JsGallery from '../../src/components/03-ui/gallery/gallery';
import JsGmap from '../../src/components/03-ui/gmap/gmap';
import JsMaterialNav from '../../src/components/03-ui/material-nav/material-nav';
import JsModal from '../../src/components/03-ui/modal/modal';
import JsPagination from '../../src/components/03-ui/pagination/pagination';
import JsSimpleHeader from '../../src/components/03-ui/simple-header/simple-header';
// import JsSiteHeader from '../../src/components/03-ui/site-header/site-header';
import JsSlider from '../../src/components/03-ui/slider/slider';
import JsTabs from '../../src/components/03-ui/subpage-tabs/subpage-tabs';
import JsTimeline from '../../src/components/03-ui/timeline/timeline';
import JsVideo from '../../src/components/03-ui/video/video';
import JsAddThis from './modules/add-this';
import JsFontSize from './modules/font-size';
import JsIasIsotope from './modules/ias-isotope';
// import JsLazyload from './modules/lazyload';
import JsMaterialDIndicator from './modules/material-indicator';
import JsMobileMenu from './modules/mobile-menu';
import JsScrollTo from './modules/smooth-scroll-to';

// Isotope doesn't seem to work with import, just require it
// To use $().isotope, we need to convert the isotope constructor into a JQuery plugin
var jQueryBridget = require('jquery-bridget');
var Isotope = require('isotope-layout');
jQueryBridget('isotope', Isotope, $);

var AOS = require('aos');

// Import SW Settings
// import JsServiceWorker from './modules/service-worker';

$(document).ready(() => {
	// Init foundation on doc ready
	$(document).foundation();

	// Object Fit Polyfill
	// https://github.com/bfred-it/object-fit-images
	objectFitImages();

	// Picture Polyfill
	// http://scottjehl.github.io/picturefill/
	pictureFill();

	// Lazysizes
	// https://github.com/aFarkas/lazysizes
	// lazysizes();

	// Initialise imported js
	JsForm.init();
	JsAccordion.init();
	JsAddThis.init();
	JsCalendar.init();
	JsFontSize.init();
	JsGallery.init();

	JsGmap.init();

	JsIasIsotope.init();
	// JsLazyload.init();
	JsMaterialDIndicator.init();
	JsMaterialNav.init();
	JsMobileMenu.init();
	JsModal.init(JsVideo);
	JsPagination.init();
	JsScrollTo.init();
	JsSimpleHeader.init();
	// JsSiteHeader.init();
	JsSlider.init();
	JsTabs.init();
	JsTimeline.init(AOS);
	JsVideo.init();

	$(window).trigger('load');
});

function initDeferredVideos () {
	if ($('.deferred-video').length > 0) {
		$('.deferred-video').each(function (key, value) {
			if ($(value).data('src')) {
				const targetSrc = $(value).data('src');
				$(value).attr('src', targetSrc);
			}
		});
	}
}

$(window).on('load', function () {
	// $('.page-preloader').fadeOut(1000);

	// Fix Equalizer woes
	$(document).foundation();
	Foundation.reInit('equalizer');

	// Fix Isotope worrys
	if ($('.isotope-grid').length) {
		// JsIsotope.init();
		setTimeout(() => {
			$('.isotope-grid').isotope('layout');
		}, 500);
	}

	// Init deferred videos
	initDeferredVideos();

	$('.fitvid').fitVids();

	if (Foundation.MediaQuery.atLeast('large')) {
		// Equalize twitter embed
		if ($('.twitter-timeline-column-height').length) {
			let targetTwitterHeight = $('.twitter-timeline-column-height').outerHeight();

			targetTwitterHeight = targetTwitterHeight - 21;

			$('.twitter-timeline-rendered').height(targetTwitterHeight);
		}
	}

	// $(window).trigger('load');
});

// Look into:
// https://github.com/kalfheim/critical-css
// https://www.npmjs.com/package/postcss-critical-css
// https://github.com/zgreen/postcss-critical-css/blob/master/example/example.js
// https://www.npmjs.com/package/laravel-mix-critical
// https://github.com/verlok/lazyload/blob/master/demos/dynamic_content.html
// https://github.com/NekR/offline-plugin
// https://www.npmjs.com/package/webpack-plugin-critical
// https://github.com/aFarkas/lazysizes
// https://medium.com/@hosarvallehernndez/service-worker-cache-with-webpack-c8811304e6da



// WEBPACK FOOTER //
// ./src/js/main.js